module.exports = __webpack_public_path__ + "img/punctaj-firma.37db6023.png";